import React, { useState, useEffect } from 'react';
import {payOfflineFee, salesforceSendFormNumber} from '../../actions/StudentAction';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios'
import { usePrompt } from '../common/usePrompt';

const ChecqueForm = (props) => {
    const detailUser = props.detail
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [amount, setAmount] = useState({ value: '', error: '', isRequired: true });
    const [checqueNumber, setChecqueNumber] = useState({ value: '', error: '', isRequired: true });
    const [transactionDate, setTransactionDate] = useState({ value: '', error: '', isRequired: true });
    const [transactionType, setTransactionType] = useState({ value: '', error: '', isRequired: true });
    const [receipt,setReceipt] = useState({name:'',value: "",id:'',error: "",isRequired: true});

    const [actualInstAmt,setActualinstAmt] = useState()
    const [feeDetail, setFeeDetail] = useState();
    const [userDetail, setUserDetail] = useState();
    const [payType, setPayType] = useState()
    const [localAmount,setLocalAmount] = useState()

    const location = useLocation();

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(30, 'days').format('YYYY-MM-DD');

    // const [formIsDirty,setFormIsDirty] = useState(false);
    const [defaultAmount,setDefaultAmount] = useState()

    // usePrompt( 'Are you sure you want to leave this page? You have unsaved changes. Do you want to leave?', formIsDirty );

    useEffect(() => {
        const {detail,feeDetail,payType}=props
        if(feeDetail!==undefined){
            if(payType.value==1){
                setAmount({...amount,value:feeDetail.installment_amount_local?feeDetail.installment_amount_local:feeDetail.installment_amount})
                setDefaultAmount(feeDetail?.installment_amount)
                setActualinstAmt(feeDetail?.actual_inst_amt)
                setLocalAmount(feeDetail?.installment_amount_local)
            }
            else if(payType.value==2){
                setAmount({...amount,value:feeDetail.lumpsum_amount_local?feeDetail.lumpsum_amount_local:feeDetail.lumpsum_amount})
                setDefaultAmount(feeDetail?.lumpsum_amount)
                setActualinstAmt(feeDetail?.actual_inst_amt)
                setLocalAmount(feeDetail?.lumpsum_amount_local)
            }
            setFeeDetail(feeDetail)
            setPayType(payType)
        }
        if(detail!==undefined){
            setUserDetail(detail)
        }

    },[props.detail,props.feeDetail,payType])


    // Validations are here  
    const validation = () => {
        let amountRegex = /^[0-9]+([.][0-9]+)?$/;
        const nameRegex = /^[a-zA-Z() ]+$/;
        let formIsValid = true
        // Student Name
        if (!amount.value) {
            formIsValid = false
            let msg = "Please enter amount"
            setAmount({ ...amount, error: msg })
        }
        if (!checqueNumber.value) {
            formIsValid = false
            let msg = "Please enter checque number"
            setChecqueNumber({ ...checqueNumber, error: msg })
        }
 
        if (!transactionDate.value) {
            formIsValid = false
            let msg = "Please select date"
            setTransactionDate({ ...transactionDate, error: msg })
        }
        if (!receipt.value) {
            formIsValid = false
            let msg = "Please please upload receipt"
            setReceipt({ ...receipt, error: msg })
        }
       
        if (formIsValid) {
            setAmount({ ...amount, error: '' });
            setChecqueNumber({ ...checqueNumber, error: '' })
            setTransactionDate({ ...transactionDate, error: '' })
            setReceipt({ ...receipt, error: '' })

        }
        return formIsValid;
    }


    const handleReceiptChange=(e)=>{
        let receiptName=e.target.name
        const value=e.target.files
        setReceipt({...receipt,name:receiptName,value:value[0],error:''})
      }

      const onSubmit = async (e) => {

        e.preventDefault(); 
        if (validation()) {
        const formData = new FormData();
        formData.append('student_id',userDetail.id)
        formData.append('amount',defaultAmount)
        formData.append('local_amount',localAmount?localAmount:'')
        formData.append('pay_transaction_id',checqueNumber.value)
        formData.append('cheque_number',checqueNumber.value)
        formData.append('transaction_date',transactionDate.value)
        formData.append('cheque_date',transactionDate.value)
        formData.append('payment_type',props.transactionType)
        formData.append('payment_mode','Offline')
        formData.append('installments_id',feeDetail.installments_id)
        formData.append('installments_number',feeDetail.installments_number)

        formData.append('scholarship_amount',feeDetail?.scholarship_amount)
        formData.append('local_scholarship_amount',feeDetail?.scholarship_amount_local)
        formData.append('net_payable_amount',feeDetail?.net_payable_amount)
        formData.append('local_net_payable_amount',feeDetail?.net_payable_amount_local)
        formData.append('scholarship_percentage',feeDetail?.scholarship_percentage)
        formData.append('actual_inst_amt',actualInstAmt)
        formData.append('local_actual_inst_amt',feeDetail?.actual_inst_amt_local)
        formData.append('course_fee',feeDetail?.total_fee)
        formData.append('local_course_fee',feeDetail?.total_fee_local)

        formData.append('fee_type',payType.value)
        formData.append('receipt',receipt.value)

        setLoading(true)
      
            await payOfflineFee(formData).then(res => {
            
                if (res.status) {
                    salesforceSendFormNumber({form_num:detailUser?.form_num,status:'payment_initiated'})
                    swal('Payment details submitted successfully','','success')
                    setLoading(false)
                    navigate('/dashboard', { state: {detail:detailUser } })
                //   props.handleDocUpload(res)
                }
                else{
                    swal(res.message,'','error')
                }
            })
            .catch(err => {
            console.log(err);
            })
        }


    }
    
    return (
        <form onSubmit={onSubmit} className="hold_mandatoryField">

            <div className="row mb-4">
                <div className="col-lg-6 mb-3">
                    <div className="form-floating diff_disable">
                        <input type="text" disabled className="form-control" value={parseFloat(amount.value).toFixed(2)} placeholder="Amount"
                            onChange={(e) => {setAmount({ ...amount, value: e.target.value, error: '' });}}
                            name="amount" />
                        <label htmlFor="floatingInput">Amount in ({feeDetail?.local_currency?feeDetail?.local_currency:'AED'})</label>
                    </div>
                    {amount.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{amount.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                    <div className="form-floating diff_disable">
                        <input type="number"  className="form-control" value={checqueNumber.value} placeholder="Enter Amount"
                            onChange={(e) => {setChecqueNumber({ ...checqueNumber, value: e.target.value, error: '' });}}
                            name="checqueNumber" />
                        <label htmlFor="floatingInput">Cheque Number</label>
                    </div>
                    {checqueNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{checqueNumber.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="date" className="form-control" min={minDate} max={currentDate} placeholder="Enter"
                            value={transactionDate.value}
                            onChange={(e) => {setTransactionDate({ ...transactionDate, value: e.target.value, error: '' });}}
                            name="trxn_date" />
                        <label htmlFor="floatingInput">Cheque Date</label>
                    </div>
                    {transactionDate.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{transactionDate.error}</div>}
                </div>
                <div className="col-lg-6 mb-3">
                <div className="form-floating diff_fileUpload">
                    <input className="form-control" type="file" name={receipt.name} 
                    accept="image/png, image/gif, image/jpeg, docx, doc, pdf" 
                    onChange={(e) => handleReceiptChange(e)}/>
                    <label htmlFor="formFile" className="form-label">Upload Receipt</label>
                </div>
                {receipt.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{receipt.error}</div>}
                </div>
                
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                {loading ? (<button type="submit" disabled className="btn btn-primary btn-lg">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Sending ...</button>) : 
                    <button type="submit" className="btn btn-primary btn-lg">Submit</button>
                }
                    <Link to="/dashboard" className="btn btn-warning ms-2 btn-lg">Cancel</Link>
                </div>

            </div>
        </form>
    )
}

export default ChecqueForm;
